import Lenis from "lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const reducedMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const touchPrimary = () => window.matchMedia("(pointer: coarse)").matches || window.innerWidth < 900;
export function mountSmoothScroll(root) {
	if (root.querySelector(".solufy-auth-page-wrapper, [data-global-presence]") || reducedMotion() || touchPrimary()) return () => {};

	gsap.registerPlugin(ScrollTrigger);
	const lenis = new Lenis({
		autoRaf: false,
		duration: 1.2,
		smoothWheel: true,
		wheelMultiplier: 1,
		syncTouch: false,
		gestureOrientation: "vertical",
		respectReducedMotion: true,
		// Lenis already subtracts each section’s CSS scroll margin.
		anchors: { offset: root.querySelector(".industry-page") ? 0 : -72, duration: 1.2 },
	});
	const progress = document.createElement("div");
	progress.className = "solufy-scroll-progress";
	progress.setAttribute("aria-hidden", "true");
	document.body.appendChild(progress);
	const updateProgress = ({ progress: value }) => {
		progress.style.transform = `scaleX(${value})`;
	};
	lenis.on("scroll", ScrollTrigger.update);
	lenis.on("scroll", updateProgress);
	const ticker = (time) => lenis.raf(time * 1000);
	gsap.ticker.add(ticker);
	gsap.ticker.lagSmoothing(0);
	const animations = [];
	ScrollTrigger.refresh();
	return () => {
		lenis.off("scroll", ScrollTrigger.update);
		lenis.off("scroll", updateProgress);
		lenis.destroy();
		gsap.ticker.remove(ticker);
		animations.forEach((animation) => {
			animation.scrollTrigger?.kill();
			animation.kill();
		});
		progress.remove();
	};
}
